/**
 * BaseTemplateInternational
 *
 * Template autónomo para visitantes internacionales con BaseTemplate (UY, ES, AU, ID, SE, CH…).
 * Réplica visual idéntica a BaseTemplate. Lee showWishlist directamente del Worker
 * (window.__TEMPLATE_CONFIG__) y activa el botón 🎁 internamente, sin necesitar
 * que Index.tsx le pase nada.
 *
 * Flujo:
 *   Worker inyecta showWishlist = true solo fuera de AR
 *   → heroCta wishlist únicamente si showWishlist (nunca por país suelto sin flag).
 *
 * Para agregar un país aquí: cambiar su config en el Cloudflare Worker a BaseTemplate.
 */

import {
  BaseTemplate,
  type TemplateProps,
} from "@/components/templates/BaseTemplate";
import { getServerTemplateConfig } from "@/lib/serverTemplateDetection";
import { BRAND_FAN_URL } from "@/lib/brandConfig";
import { trackTemplateCta } from "@/lib/templateCtaAnalytics";

function WishlistButton() {
  return (
    <a
      href={`${BRAND_FAN_URL}/wishlist`}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() =>
        trackTemplateCta({
          prefix: "base_intl",
          template: "BaseTemplateInternational",
          action: "wishlist",
          href: `${BRAND_FAN_URL}/wishlist`,
          flowName: "hero",
        })
      }
      className="inline-flex items-center gap-3 py-3.5 px-5 bg-black/[0.08] backdrop-blur-[16px] border border-black/[0.15] rounded-[14px] hover:bg-black/[0.12] hover:border-black/[0.25] transition-all duration-200 max-w-[360px] mx-auto"
    >
      <span className="text-2xl flex-shrink-0" role="img" aria-label="Regalo">
        🎁
      </span>
      <span className="text-[15px] font-semibold text-black leading-tight">
        Ingresa a mi wishlist de cumpleaños
      </span>
    </a>
  );
}

type BaseTemplateInternationalProps = Omit<TemplateProps, "heroCta">;

export const BaseTemplateInternational: React.FC<BaseTemplateInternationalProps> = (props) => {
  // Lee showWishlist del Worker directamente — no necesita que Index.tsx lo pase
  const templateConfig = getServerTemplateConfig();
  const heroCta = templateConfig?.showWishlist === true ? (
    <WishlistButton />
  ) : null;

  return <BaseTemplate {...props} heroCta={heroCta} />;
};
